import { render, staticRenderFns } from "./invite_collaborators_modal.vue?vue&type=template&id=0769398c&scoped=true&"
import script from "./invite_collaborators_modal.vue?vue&type=script&lang=js&"
export * from "./invite_collaborators_modal.vue?vue&type=script&lang=js&"
import style0 from "./invite_collaborators_modal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./invite_collaborators_modal.vue?vue&type=style&index=1&id=0769398c&lang=scss&scoped=true&"
import style2 from "./invite_collaborators_modal.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0769398c",
  null
  
)

export default component.exports